<!-- cv简历信息表-教育背景-组件级 -->
<template>
  <div class='detail-wrap'>
    <div class='detail-container'>
      <div class='cv-detail en'>
        <h4 class='pad-top'>High School</h4>
        <ul>
          <li>
            <span class='cv-detail-name'>School Name：</span>
            <span class='cv-detail-val'>{{educationDetailEn.highSchool && educationDetailEn.highSchool.name}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Time of Entrance：</span>
            <span class='cv-detail-val'>{{educationDetailEn.highSchool && educationDetailEn.highSchool.entranceTime}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Time of Graduation：</span>
            <span class='cv-detail-val'>{{educationDetailEn.highSchool && educationDetailEn.highSchool.graduationTime}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Address：</span>
            <span class='cv-detail-val'>{{educationDetailEn.highSchool && educationDetailEn.highSchool.address}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Zip Code：</span>
            <span class='cv-detail-val'>{{educationDetailEn.highSchool && educationDetailEn.highSchool.zipCode}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Type of School：</span>
            <span class='cv-detail-val'>{{educationDetailEn.highSchool && educationDetailEn.highSchool.schoolType && new Map(schoolTypeEnMap).get(educationDetailEn.highSchool.schoolType)}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Educational System：</span>
            <span class='cv-detail-val'>{{educationDetailEn.highSchool && educationDetailEn.highSchool.eduSys && new Map(educationalSystemEnMap).get(educationDetailEn.highSchool.eduSys)}}</span>
          </li>
          <li v-if="educationDetailEn.highSchool && educationDetailEn.highSchool.eduSys === 'PHSC'">
            <span class='cv-detail-name'>Name of Special Class：</span>
            <span class='cv-detail-val'>{{educationDetailEn.highSchool && educationDetailEn.highSchool.className}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Class Year Ranking：</span>
            <span class='cv-detail-val'>{{educationDetailEn.highSchool && educationDetailEn.highSchool.rank}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Total Number of Students in Grade：</span>
            <span class='cv-detail-val'>{{educationDetailEn.highSchool && educationDetailEn.highSchool.gradeMembers}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Class List：</span>
            <span class='cv-detail-val'>{{educationDetailEn.highSchool && educationDetailEn.highSchool.rankRatio}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>GPA/Grades at School：</span>
            <span class='cv-detail-val'>{{educationDetailEn.highSchool && educationDetailEn.highSchool.gpa}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>GPA Scale：</span>
            <span class='cv-detail-val'>{{educationDetailEn.highSchool && educationDetailEn.highSchool.gpaScale && new Map(GPAScaleEnMap).get(educationDetailEn.highSchool.gpaScale)}}</span>
          </li>
          <li v-if="educationDetailEn.highSchool && educationDetailEn.highSchool.gpaScale === 'OTHER'">
            <span class='cv-detail-name'>GPA Notes：</span>
            <span class='cv-detail-val'>{{educationDetailEn.highSchool && educationDetailEn.highSchool.gpaNotes}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Is the Institution a Boarding School：</span>
            <span class='cv-detail-val'>{{educationDetailEn.highSchool && educationDetailEn.highSchool.boarding && new Map(boardingInstitutionEnMap).get(educationDetailEn.highSchool.boarding)}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>If yes, Does the Applicant Board：</span>
            <span class='cv-detail-val'>{{educationDetailEn.highSchool && educationDetailEn.highSchool.resident && new Map(applicantBoardEnMap).get(educationDetailEn.highSchool.resident)}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Head Teacher Name：</span>
            <span class='cv-detail-val'>{{educationDetailEn.highSchool && educationDetailEn.highSchool.headTeacherName}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Head Teacher E-mail：</span>
            <span class='cv-detail-val'>{{educationDetailEn.highSchool && educationDetailEn.highSchool.headTeacherEmail}}</span>
          </li>
        </ul>
        <h4 class='pad-top'>Other High Schools Attended</h4>
        <ul>
          <li>
            <span class='cv-detail-name'>School Name：</span>
            <span class='cv-detail-val'>{{educationDetailEn.otherHighSchool && educationDetailEn.otherHighSchool.name}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Time of Entrance：</span>
            <span class='cv-detail-val'>{{educationDetailEn.otherHighSchool && educationDetailEn.otherHighSchool.entranceTime}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Time of Graduation：</span>
            <span class='cv-detail-val'>{{educationDetailEn.otherHighSchool && educationDetailEn.otherHighSchool.graduationTime}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Address：</span>
            <span class='cv-detail-val'>{{educationDetailEn.otherHighSchool && educationDetailEn.otherHighSchool.address}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Zip Code：</span>
            <span class='cv-detail-val'>{{educationDetailEn.otherHighSchool && educationDetailEn.otherHighSchool.zipCode}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Type of School：</span>
            <span class='cv-detail-val'>{{educationDetailEn.otherHighSchool && educationDetailEn.otherHighSchool.schoolType && new Map(schoolTypeEnMap).get(educationDetailEn.otherHighSchool.schoolType)}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Class Year Ranking：</span>
            <span class='cv-detail-val'>{{educationDetailEn.otherHighSchool && educationDetailEn.otherHighSchool.rank}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Total Number of Students in Grade：</span>
            <span class='cv-detail-val'>{{educationDetailEn.otherHighSchool && educationDetailEn.otherHighSchool.gradeMembers}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Class List：</span>
            <span class='cv-detail-val'>{{educationDetailEn.otherHighSchool && educationDetailEn.otherHighSchool.rankRatio}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>GPA/Grades at School：</span>
            <span class='cv-detail-val'>{{educationDetailEn.otherHighSchool && educationDetailEn.otherHighSchool.gpa}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>GPA Scale：</span>
            <span class='cv-detail-val'>{{educationDetailEn.otherHighSchool && educationDetailEn.otherHighSchool.gpaScale && new Map(GPAScaleEnMap).get(educationDetailEn.otherHighSchool.gpaScale)}}</span>
          </li>
          <li v-if="educationDetailEn.otherHighSchool && educationDetailEn.otherHighSchool.gpaScale === 'OTHER'">
            <span class='cv-detail-name'>GPA Notes：</span>
            <span class='cv-detail-val'>{{educationDetailEn.otherHighSchool && educationDetailEn.otherHighSchool.gpaNotes}}</span>
          </li>
        </ul>
        <h4 class='pad-top'>Middle School Attended</h4>
        <ul>
          <li>
            <span class='cv-detail-name'>School Name：</span>
            <span class='cv-detail-val'>{{educationDetailEn.middleSchool && educationDetailEn.middleSchool.name}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Time of Entrance：</span>
            <span class='cv-detail-val'>{{educationDetailEn.middleSchool && educationDetailEn.middleSchool.entranceTime}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Time of Graduation：</span>
            <span class='cv-detail-val'>{{educationDetailEn.middleSchool && educationDetailEn.middleSchool.graduationTime}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Address：</span>
            <span class='cv-detail-val'>{{educationDetailEn.middleSchool && educationDetailEn.middleSchool.address}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Zip Code：</span>
            <span class='cv-detail-val'>{{educationDetailEn.middleSchool && educationDetailEn.middleSchool.zipCode}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Type of School：</span>
            <span class='cv-detail-val'>{{educationDetailEn.middleSchool && educationDetailEn.middleSchool.schoolType && new Map(schoolTypeEnMap).get(educationDetailEn.middleSchool.schoolType)}}</span>
          </li>
        </ul>
        <h4 class='pad-top'>Elementary School Attended</h4>
        <ul>
          <li>
            <span class='cv-detail-name'>School Name：</span>
            <span class='cv-detail-val'>{{educationDetailEn.elementarySchool && educationDetailEn.elementarySchool.name}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Time of Entrance：</span>
            <span class='cv-detail-val'>{{educationDetailEn.elementarySchool && educationDetailEn.elementarySchool.entranceTime}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Time of Graduation：</span>
            <span class='cv-detail-val'>{{educationDetailEn.elementarySchool && educationDetailEn.elementarySchool.graduationTime}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Address：</span>
            <span class='cv-detail-val'>{{educationDetailEn.elementarySchool && educationDetailEn.elementarySchool.address}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Zip Code：</span>
            <span class='cv-detail-val'>{{educationDetailEn.elementarySchool && educationDetailEn.elementarySchool.zipCode}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Type of School：</span>
            <span class='cv-detail-val'>{{educationDetailEn.elementarySchool && educationDetailEn.elementarySchool.schoolType && new Map(schoolTypeEnMap).get(educationDetailEn.elementarySchool.schoolType)}}</span>
          </li>
        </ul>
        <h4 class='pad-top'>Additional Information</h4>
        <ul>
          <li>
            <span class='cv-detail-name'>Additional Information 1：</span>
            <span class='cv-detail-val'>{{educationDetailEn.otherInfo1}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Additional Information 2：</span>
            <span class='cv-detail-val'>{{educationDetailEn.otherInfo2}}</span>
          </li>
        </ul>
        <p class='pad-top warning'>If the student currently attends college, please specify the following information</p>
        <h4>College</h4>
        <ul>
          <li>
            <span class='cv-detail-name'>School Name：</span>
            <span class='cv-detail-val'>{{educationDetailEn.univer && educationDetailEn.univer.name}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Time of Entrance：</span>
            <span class='cv-detail-val'>{{educationDetailEn.univer && educationDetailEn.univer.entranceTime}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Time of Graduation：</span>
            <span class='cv-detail-val'>{{educationDetailEn.univer && educationDetailEn.univer.graduationTime}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Name of College：</span>
            <span class='cv-detail-val'>{{educationDetailEn.univer && educationDetailEn.univer.college}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Major(s)：</span>
            <span class='cv-detail-val'>{{educationDetailEn.univer && educationDetailEn.univer.major}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Address：</span>
            <span class='cv-detail-val'>{{educationDetailEn.univer && educationDetailEn.univer.address}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Zip Code：</span>
            <span class='cv-detail-val'>{{educationDetailEn.univer && educationDetailEn.univer.zipCode}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Type of School：</span>
            <span class='cv-detail-val'>{{educationDetailEn.univer && educationDetailEn.univer.schoolType && new Map(schoolTypeEnMap).get(educationDetailEn.univer.schoolType)}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>GPA/Grades at School：</span>
            <span class='cv-detail-val'>{{educationDetailEn.univer && educationDetailEn.univer.gpa}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>GPA Scale：</span>
            <span class='cv-detail-val'>{{educationDetailEn.univer && educationDetailEn.univer.gpaScale && new Map(GPAScaleEnMap).get(educationDetailEn.univer.gpaScale)}}</span>
          </li>
          <li v-if="educationDetailEn.univer && educationDetailEn.univer.gpaScale === 'OTHER'">
            <span class='cv-detail-name'>GPA Notes：</span>
            <span class='cv-detail-val'>{{educationDetailEn.univer && educationDetailEn.univer.gpaNotes}}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import cvService from '@/api/undergraduate/cv'
import { schoolTypeEnMap, educationalSystemEnMap, GPAScaleEnMap, boardingInstitutionEnMap, applicantBoardEnMap } from '../constants'
import './cv-detail.less'
export default {
  name: '',
  components: {},
  data () {
    return {
      // 学校类型映射
      schoolTypeEnMap,
      // 课程体系映射
      educationalSystemEnMap,
      // GPA scale映射
      GPAScaleEnMap,
      // 是否寄宿制学校映射
      boardingInstitutionEnMap,
      // 是否住校映射
      applicantBoardEnMap,
      // 学员num
      menteeNum: '',
      // 教育背景详情
      educationDetailEn: {}
    }
  },
  computed: {},
  mounted () {
    this.menteeNum = this.$route.params.id
    this.getEducationDetailEn()
  },
  methods: {
    // 获取教育背景-en
    getEducationDetailEn () {
      cvService.cvEducationDetailEn({ num: this.menteeNum }).then(res => {
        // 粗糙处理方式
        let data = res.data.model
        let temp = res.data.model
        if (data) {
          if (data.highSchool) {
            data.highSchool.boarding = (temp.highSchool.boarding || String(temp.highSchool.boarding) === 'false') ? String(temp.highSchool.boarding) : ''
            data.highSchool.resident = (temp.highSchool.resident || String(temp.highSchool.resident) === 'false') ? String(temp.highSchool.resident) : ''
          }
          this.educationDetailEn = data
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
